module.exports = __webpack_public_path__ + "static/media/diatomite.2de37619.jpg";